<template>
  <div class="bs-wizard">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "bs-wizard",
  props: {}
};
</script>

<style>
.bs-wizard {
  margin-top: 40px;
}
.bs-wizard {
  border-bottom: solid 1px #e0e0e0;
  padding: 0 0 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/BsWizard/BsWizard.vue